<template>
  <Modal>
    <div :style="styles.modalHeader">
      <h3 :style="styles.modalTitle">Add Card To Sequence</h3>
      <button class="button__action" @click="openNewCardModal">Create New Action Card</button>
    </div>
    <LibraryGrid v-if="checkCardsLoaded && getCards" :baseStyle="{paddingTop: 0}" fullWidth>
      <section
        v-for="(card, index) of getCards"
        :key="index"
        class="cardWrap"
        @click="addCardToCurrentSequence(card)"
      >
        <div :style="styles.cardContainer">
          <p :style="styles.cardName">{{card.legacyName}}</p>
          <p>{{card.displayName}}</p>
        </div>
      </section>
    </LibraryGrid>
  </Modal>
</template>
<script>
import Modal from '../general/Modal';
import LibraryGrid from '../general/LibraryGrid';
import CloseIcon from 'vue-material-design-icons/Close';
import Services from '../../services/Services';
import store from '../../store';
export default {
  name: 'AddCardToSequenceModal',
  components: {
    LibraryGrid,
    Modal
  },
  computed: {
    checkCardsLoaded() {
      return store.getters.checkCardsReady;
    },
    getCards() {
      return store.getters.getCards;
    }
  },
  methods: {
    addCardToCurrentSequence(card) {
      const sequenceCards = store.getters.getSequenceCards;
      sequenceCards.push(card);
      store.commit('setSequenceCards', sequenceCards);
      store.commit('setSequenceStatus', true);
      store.commit('hideModals', true);
    },
    openNewCardModal() {
        store.commit('showCreateCardModal', true);
    }
  },
  mounted() {
      Services.getCards();
  },
  data() {
    return {
      hideModal: Services.hideModals,
      cardsLoaded: false,
      styles: {
        mediaGrid: confirmationScreen => ({
          display: confirmationScreen ? 'none' : 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap'
        }),
        modal: {
          background: '#fff',
          width: '90vw',
          height: '90vh',
          maxHeight: '90vh',
          margin: '0 auto',
          padding: '2rem',
          overflowY: 'scroll',
          overflowX: 'hidden',
          position: 'relative'
        },
        mediaContainer: {
          margin: 'auto',
          width: '100%',
          maxWidth: '500px'
        },
        confirmationBase: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center'
        },
        buttonContainer: {
          display: 'flex',
          margin: 'auto',
          flexDirection: 'row',
          flexWrap: 'no-wrap',
          width: '235px'
        },
        confirmationButtons: {
          display: 'block',
          width: '49%'
        },
        modalHeader: {
          boxSizing: 'border-box',
          marginBottom: '1.5rem',
          paddingBottom: '0.5rem',
          borderBottom: '1px solid #444',
          display: 'flex',
          justifyContent: 'space-between',
          marginLeft: '10px',
          marginRight: '30px'
        },
        removeButton: {
          background: '#eb4d4b',
          fontSize: '0.9em',
          color: '#fff',
          borderRadius: '5px',
          padding: '5px',
          margin: 'auto 0 auto 10px',
          border: '0',
          ':hover': {
            opacity: '0.9'
          }
        },
        cancelButton: {
          background: '#888'
        },
        modalTitle: {
          color: '#444',
          fontSize: '1.5rem'
        },
        modalGridContainer: {
          overflow: 'scroll'
        },
        closeIcon: {
          position: 'fixed',
          top: '10px',
          right: '10px',
          fontSize: '2em',
          color: '#ddd',
          cursor: 'pointer'
        },
        yesButton: {
          background: '#6ab04c'
        },
        goBackLink: {
          color: 'rgb(9, 163, 237)',
          cursor: 'pointer',
          marginTop: '2rem',
          ':hover': {
            opacity: '0.9'
          }
        },
        backIcon: {
          position: 'relative',
          top: '7px'
        },
        cardWrap: {
          background: '#fff',
          display: 'flex',
          border: '1px solid #eee',
          padding: '10px',
          flexFlow: 'row nowrap',
          width: 'calc(33.33% - 20px)',
          margin: '10px',
          ':hover': {
            border: '1px solid #888',
            cursor: 'pointer'
          }
        },
        cardContainer: {
          display: 'flex',
          flexFlow: 'column nowrap'
        },
        cardPreview: {
          background: 'teal',
          position: 'relative',
          padding: '20px'
        },
        cardName: {
          color: '#aaa',
          fontSize: '0.9em',
          marginBottom: '0'
        },
        cardMetadataSection: {
          display: 'flex',
          flexFlow: 'column nowrap',
          padding: '40px',
          width: '100%'
        },
        cardType: {
          margin: '20px auto 10px 20px',
          color: '#888'
        }
      }
    };
  }
};
</script>
<style lang="scss" scoped>
p {
  margin: 10px 0;
}
.cardWrap {
  background: #fff;
  display: flex;
  border: 1px solid #eee;
  padding: 10px;
  box-sizing: border-box;
  flex-flow: row nowrap;
  width: calc(33.33% - 20px);
  margin: 10px;
  &:hover {
    border: 1px solid #888;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/AddCardToSequence.vue